export default __webpack_public_path__ + "static/media/sellicon.5a6ad362.png";